import { EVisibility } from '@/types/types';

import { TBroadcastScheduleProgramBodySegmentToolkitPeopleForm } from '../types';

const PEOPLE_FORM_DEFAULT_VALUES: TBroadcastScheduleProgramBodySegmentToolkitPeopleForm = {
  people_id: '',
  entity_label: '',
  entity_score: 100,
  start_datetime: null,
  end_datetime: null,
  parameters: {
    start_frame: null,
    end_frame: null,
    bbox: null,
    landmarks: [],
    visibility: EVisibility.MEDIA,
  },
  segment_people_id: '',
  review_state: 1,
};

export { PEOPLE_FORM_DEFAULT_VALUES };
